module.exports = __webpack_public_path__ + "img/image_4.db91ee34.png";